import { OjEvent, StackEvent } from '../../../shared/api';

export function isStackEvent(event: OjEvent | StackEvent): event is StackEvent {
  return !('all_day' in event);
}
